export default "__VITE_ASSET__eb59a850__"